/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Avoid deprecated APIs, use portals instead of rendering to a new root
 *	> 'render' import from 'owa-react-dom' is restricted. Use react portals instead of rendering into a new root */
import { render } from 'owa-react-dom';
import { lazyGetIframeUrl as getIframeUrl, feedbackScenarioName } from 'diagnostics-and-support';
import FeedbackDialog from './FeedbackDialog';
import React from 'react';
import { ThemeProvider } from '@fluentui/react/lib/Theme';

export default function RenderFeedbackDialog(appName: string) {
    const featureFlagsDiv = document.createElement('div');
    window.document.body.appendChild(featureFlagsDiv);

    getIframeUrl.importAndExecute(feedbackScenarioName, appName).then(url => {
        render(
            <ThemeProvider role={'complementary'} tabIndex={-1}>
                <FeedbackDialog iframeUrl={url} scenario={feedbackScenarioName} appName={appName} />
            </ThemeProvider>,
            featureFlagsDiv
        );
    });
}
